// src/services/RoomStatusService.js

let lastDemoRoomData = null;
const MAX_INDEX = 10;
let demoTimerStart = null;

const deepClone = (obj) => JSON.parse(JSON.stringify(obj ?? {}));

const getPlayers = (items) =>
	(Array.isArray(items) ? items : []).filter((item) => item.type === 1);

const sortByItemIndex = (items) =>
	[...items].sort((a, b) => {
		const ia = typeof a.itemIndex === 'number' ? a.itemIndex : 0;
		const ib = typeof b.itemIndex === 'number' ? b.itemIndex : 0;
		return ia - ib; // asc, poi la select nella query li riordina come vuoi
	});

const advanceOneRandomPlayer = (items) => {
	const safeItems = Array.isArray(items) ? items : [];
	const players = getPlayers(safeItems);

	// prendo solo chi non è ancora arrivato al MAX_INDEX
	const candidates = players.filter((p) => {
		const idx = typeof p.itemIndex === 'number' ? p.itemIndex : 0;
		return idx < MAX_INDEX;
	});

	// se sono tutti completi, non tocco nulla
	if (!candidates.length) return safeItems;

	const randomPlayer =
		candidates[Math.floor(Math.random() * candidates.length)];

	return safeItems.map((item) => {
		if (item.sessionId !== randomPlayer.sessionId) return item;

		const currentIndex =
			typeof item.itemIndex === 'number' ? item.itemIndex : 0;
		const newIndex = Math.min(MAX_INDEX, currentIndex + 1);

		return { 
			...item,
			itemIndex: newIndex,
			maxItemIndex: newIndex,
			isCompleted: newIndex >= MAX_INDEX ? true : item.isCompleted,
		};
	});
};

// start/stop timer demo
export const startDemoTimer = () => {
	console.log("Avvio il timer....")
	if (!demoTimerStart) demoTimerStart = Date.now();
};

export const stopDemoTimer = () => {
	if (!demoTimerStart) return null;
	console.log("Stoppo il timer....")
	const elapsedSec = Math.floor((Date.now() - demoTimerStart) / 1000);
	demoTimerStart = null;
	if (lastDemoRoomData) lastDemoRoomData.totalTime = elapsedSec;
	return elapsedSec;
};

/**
 * DEMO: finto backend
 */
export const getDemoRoomStatus = async (api, isFinalStep) => {
	if (isFinalStep) {  
		//return JSON.parse(JSON.stringify(lastDemoRoomData ?? {}));
		try {
			const { data } = await api.get('/react-app/json/room-status-final.json');
			const cloned = JSON.parse(JSON.stringify(data));
			//if (lastDemoRoomData?.totalTime != null) cloned.totalTime = lastDemoRoomData.totalTime;
			return cloned;
		} catch (e) {
			return JSON.parse(JSON.stringify(lastDemoRoomData ?? {}));
		}
	} 

	// prima chiamata: prendo il mock dal JSON
	if (!lastDemoRoomData) {
		const { data } = await api.get('/react-app/json/room-status.json');
		lastDemoRoomData = data;
	}

	const base = deepClone(lastDemoRoomData);
	const advancedItems = advanceOneRandomPlayer(base.items);
	const sortedItems = sortByItemIndex(advancedItems);

	lastDemoRoomData = {
		...base,
		items: sortedItems,
		totalTime: lastDemoRoomData.totalTime ?? null,
	};

	return lastDemoRoomData;
};
